import { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@trello/nachos/button';

import styles from './BoardSidebarLoadingError.less';

export class BoardSidebarLoadingError extends Component {
  private reloadPage = () => window.location.reload();

  render() {
    return (
      <div className={styles.errorMessage}>
        <div className="board-menu-header-content">
          <h3 className="board-menu-header-title js-board-menu-title-text">
            <FormattedMessage
              id="view title.menu"
              defaultMessage="Menu"
              description="Title for the menu"
            />
          </h3>
        </div>
        <hr role="presentation" className={'board-menu-header-divider'} />
        <h4>
          <FormattedMessage
            id="templates.error.menu-loading-error"
            defaultMessage="The menu could not be loaded at this time."
            description="Error message for the menu"
          />
        </h4>
        <p>
          <FormattedMessage
            id="templates.error.reload-call-to-action"
            defaultMessage="You may want to try reloading this page."
            description="Call to action for the menu"
          />
        </p>
        <Button appearance={'primary'} onClick={this.reloadPage}>
          <FormattedMessage
            id="templates.connect_failed.reload-page"
            defaultMessage="Reload page"
            description="Button to reload the page"
          />
        </Button>
      </div>
    );
  }
}
